"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var GamingPad01 = function GamingPad01(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M5.9999 11h4m-2-2v4m7-1h.01m2.99-2h.01m-7.5611-5h3.1021c2.6249 0 3.9374 0 4.9675.4974a5 5 0 0 1 2.1621 2.0132c.5696.9921.6631 2.3012.8501 4.9194l.246 3.4445C21.8973 17.5634 20.5597 19 18.8664 19a2.917 2.917 0 0 1-2.2413-1.0498l-.3752-.4502c-.3431-.4118-.5148-.6177-.7101-.7841a3 3 0 0 0-1.4355-.6723C13.8514 16 13.5834 16 13.0473 16h-2.0948c-.5361 0-.8041 0-1.057.0436a3 3 0 0 0-1.4355.6723c-.1954.1664-.367.3723-.7101.7841l-.3752.4502A2.918 2.918 0 0 1 5.1334 19C3.44 19 2.1025 17.5634 2.223 15.8745l.246-3.4445c.187-2.6182.2806-3.9273.8502-4.9194a5 5 0 0 1 2.162-2.0132C6.5116 5 7.824 5 10.4489 5"
    })
  }));
};
var _default = exports["default"] = GamingPad01;